import { Action, createReducer, on } from '@ngrx/store'

import { adapter, initialState } from './state'
import { CreateCustomChannelComplete, DeleteCustomChannelComplete, GetCustomChannelsComplete } from './actions'
import { upsertMany } from '@tokeet-frontend/utility'

export const reducer = createReducer(
  initialState,
  on(GetCustomChannelsComplete, (state, { items }) => upsertMany(adapter, items, { ...state, isLoaded: true })),
  on(CreateCustomChannelComplete, (state, { item }) => adapter.addOne(item, state)),
  on(DeleteCustomChannelComplete, (state, { id }) => adapter.removeOne(id, state))
)

export function customChannelReducer(state: typeof initialState | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
